<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent width="500">
      <template v-slot:activator="{ on }">
        <v-btn  color="accent" v-on="on">Add User</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Add User</v-card-title>

        <v-card-text>
          <v-text-field
            v-model="form.userName"
            label="user name"
            hint="This will used for login"
            persistent-hint
            required
          ></v-text-field>
          <v-text-field v-model="form.mobileNumber" label="mobile number" required></v-text-field>
          <v-text-field v-model="form.password" label="password" required></v-text-field>
          <v-text-field v-model="form.confirmPassword" label="confirm password" required></v-text-field>

          <v-text-field v-model="form.city" label="city" required></v-text-field>
          <v-text-field v-model="form.branch" label="branch" required></v-text-field>
          <v-select v-model="form.userType" :items="items" label="user type"></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
             <v-btn color="primary" flat @click="closeForm">Close</v-btn>
          <v-btn color="primary" flat @click="submitData">Create</v-btn>
         
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
   mounted() {
  
  },
  data() {
    return {
      form: {
        userName: "",
        mobileNumber: "",
        password: "",
        confirmPassword: "",
        city: "",
        branch: "",
        userType: "",
        email:""
      },
      dialog: false,
      items: ["admin", "manager","feild executive"]
    };
  },
  methods: {
    submitData: function() {
      this.$emit("clicked", JSON.stringify(this.form));
      this.dialog = false;
      this.form ={};
    },
    closeForm: function(){
       this.dialog = false;
      this.form ={};
    }
  }
};
</script>